export default __webpack_public_path__ + "static/media/SWT1980.34I-42001_-25161_0.428fb78e.jpg";